import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';
import { FiHome } from 'react-icons/fi';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-12rem)]">
      <h1 className="text-6xl font-bold text-primary">404</h1>
      <h2 className="text-2xl font-semibold mt-4">页面未找到</h2>
      <p className="text-muted-foreground mt-2 mb-6">
        您访问的页面不存在或已被移除
      </p>
      <Link to="/">
        <Button className="flex items-center gap-2">
          <FiHome className="h-4 w-4" />
          返回首页
        </Button>
      </Link>
    </div>
  );
};

export default NotFoundPage;
